import React, {Component} from 'react';
import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import classnames from 'classnames';

class AutoSuggestItem extends Component {
    constructor(props) {
        super(props);

        this._onClick = this._onClick.bind(this);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    _onClick(evt) {
        evt.preventDefault();

        const {
            onSuggestionSelect
        } = this.props;

        if (onSuggestionSelect) {
            onSuggestionSelect();
        }
    }

    _generateDataTestId(prefix, purpose) {
        if (typeof purpose === 'undefined') {
            return `${prefix}-default`;
        } else {
            return `${prefix}-${purpose}`;
        }
    }

    render() {
        const {
            active,
            className,
            suggestion,
            onSuggestionMouseDown,
            onSuggestionMouseOut,
            dataTestIdPurposeForItem
        } = this.props;
        const classes = classnames(
            'AutoSuggestInput-item',
            {'AutoSuggestInput-item-active': active},
            className
        );

        return (
            <li
                className={classes}
                onClick={this._onClick}
                onMouseDown={onSuggestionMouseDown}
                onMouseOut={onSuggestionMouseOut}
                data-testid={this._generateDataTestId('AutoSuggestItem-item', dataTestIdPurposeForItem)}
            >
                {suggestion.label}
            </li>
        );
    }
}

AutoSuggestItem.propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    suggestion: PropTypes.object.isRequired,
    onSuggestionSelect: PropTypes.func,
    onSuggestionMouseDown: PropTypes.func,
    onSuggestionMouseOut: PropTypes.func,
    dataTestIdPurposeForItem: PropTypes.string
};

AutoSuggestItem.defaultProps = {
    active: false,
    className: ''
};

export default AutoSuggestItem;



// WEBPACK FOOTER //
// ./frontend/src/js/components/auto-suggest/AutoSuggestItem.jsx